export const projects = [
  {
    title: "Project One",
    description: "This is a description for project one.",
    techStack: ["React", "Node.js", "MongoDB"],
    image: "https://via.placeholder.com/300",
    githubLink: "#",
    liveDemoLink: "#"
  },
  {
    title: "Project Two",
    description: "This is a description for project two.",
    techStack: ["Vue", "Firebase", "Tailwind CSS"],
    image: "https://via.placeholder.com/300",
    githubLink: "#",
    liveDemoLink: "#"
  }
];

